import { generateSimpleWhatsAppLink } from './HeroSection';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const rooms = [
  {
    title: '1+1 Mutfaklı Aile Odaları',
    desc: 'Aileler ve uzun süreli konaklamalar için konforlu, kullanışlı ve ferah yaşam alanı sunar. Mutfaklı yapısıyla tatil boyunca daha rahat bir konaklama deneyimi sağlar.',
    highlights: ['Aileler için uygun', 'Uzun süreli konaklamalara uygun', 'Mutfaklı yaşam alanı', 'Daha geniş kullanım imkanı'],
    buttonText: 'Aile Odası İçin Fiyat Sor',
    roomType: '1+1 Mutfaklı Aile Odası',
    image: 'https://readdy.ai/api/search-image?query=Bright%20spacious%20family%20hotel%20room%20interior%20with%20small%20kitchenette%20area%2C%20cozy%20living%20space%2C%20natural%20olive%20green%20and%20beige%20decor%20tones%2C%20large%20window%20with%20garden%20view%2C%20warm%20natural%20light%2C%20clean%20boutique%20hotel%20aesthetic%2C%20editorial%20interior%20photography%2C%20high%20detail%20comfortable%20home%20atmosphere&width=800&height=600&seq=room-family-01&orientation=landscape',
  },
  {
    title: 'Standart Odalar',
    desc: 'Çiftler, tek kişi veya iki kişilik konaklamalar için rahat ve şık bir seçenek sunar. Sade, konforlu ve huzurlu butik otel konaklaması isteyenler için idealdir.',
    highlights: ['Çiftler için uygun', 'Tek veya iki kişilik konaklama', 'Rahat ve sade kullanım', 'Butik otel konforu'],
    buttonText: 'Standart Oda İçin Fiyat Sor',
    roomType: 'Standart Oda',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20boutique%20hotel%20standard%20room%20interior%2C%20queen%20bed%20with%20crisp%20white%20linens%2C%20soft%20olive%20green%20accents%2C%20natural%20wood%20furniture%2C%20large%20window%20with%20garden%20greenery%20view%2C%20warm%20morning%20light%2C%20minimal%20clean%20design%2C%20serene%20peaceful%20atmosphere%2C%20editorial%20travel%20photography%20high%20detail&width=800&height=600&seq=room-standard-01&orientation=landscape',
  },
];

export default function RoomsSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal({ threshold: 0.2 });
  const { ref: cardRef, isVisible: cardVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="odalar" className="w-full py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div ref={headerRef} className={`text-center mb-10 md:mb-14 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Konaklama İhtiyacınıza Uygun{' '}
            <span className="text-accent-500">Oda Seçenekleri</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Her misafirimiz için özenle hazırlanmış, konforlu ve ferah oda seçeneklerimiz.
          </p>
        </div>

        {/* Room Cards */}
        <div ref={cardRef} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {rooms.map((room, i) => (
            <div
              key={room.title}
              className={`group bg-background-100 rounded-3xl overflow-hidden border border-background-200/60 hover:shadow-lg transition-all duration-700 ${cardVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${i * 200}ms` }}
            >
              {/* Image */}
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={room.image}
                  alt={room.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                  {room.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {room.desc}
                </p>

                {/* Highlights */}
                <div className="flex flex-wrap gap-2 mb-5">
                  {room.highlights.map((h) => (
                    <span
                      key={h}
                      className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-50 text-primary-700 rounded-full text-xs font-medium"
                    >
                      <i className="ri-check-line" />
                      {h}
                    </span>
                  ))}
                </div>

                {/* Button */}
                <a
                  href={generateSimpleWhatsAppLink(room.roomType)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 text-background-50 rounded-xl font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer hover:scale-[1.02] active:scale-[0.98]"
                >
                  <i className="ri-whatsapp-line" />
                  {room.buttonText}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}